
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import HelpdeskAssignee from '@/components/helpdesk/HelpdeskAssignee.vue';
import {IMayordomoUser, searchMayordomoUsers, USER_SEARCH_MIN_LENGTH} from '@/services/helpdeskUserLookup';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

@Component({name: 'HelpdeskAssigneePicker', components: {HelpdeskAssignee}})
export default class HelpdeskAssigneePicker extends Vue {
  @Prop({default: ''}) value!: string;
  // Field look (bordered, chevron) for forms; plain for grids/headers.
  @Prop({type: Boolean, default: false}) field!: boolean;
  @Prop({type: Boolean, default: false}) large!: boolean;
  @Prop({type: Boolean, default: false}) saving!: boolean;
  @Prop({type: Boolean, default: false}) disabled!: boolean;

  open = false;
  query = '';
  results: IMayordomoUser[] = [];
  searching = false;
  minLength = USER_SEARCH_MIN_LENGTH;
  private timer: any = null;

  get myEmail(): string {
    const u = this.$store.getters['authModule/userData'];
    return (u && u.email) ? u.email : '';
  }

  // A typed address that isn't already a search result can still be assigned.
  get typedEmail(): string {
    const q = this.query.trim().toLowerCase();
    if (!EMAIL_RE.test(q)) return '';
    return this.results.some((u) => (u.email || '').toLowerCase() === q) ? '' : q;
  }

  onQuery() {
    clearTimeout(this.timer);
    const q = this.query;
    if (q.trim().length < this.minLength) { this.results = []; this.searching = false; return; }
    this.searching = true;
    this.timer = setTimeout(() => {
      searchMayordomoUsers(q).catch(() => [] as IMayordomoUser[]).then((users) => {
        if (q !== this.query) return;
        this.results = users;
        this.searching = false;
      });
    }, 300);
  }

  pickTyped() {
    if (this.typedEmail) this.pick(this.typedEmail);
    else if (this.results.length === 1) this.pick(this.results[0].email);
  }

  pick(email: string) {
    this.open = false;
    this.query = '';
    this.results = [];
    if (email !== this.value) {
      this.$emit('input', email);
      this.$emit('change', email);
    }
  }
}
